import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';
import { getVideoDetailLocalStorage, setVideoDetailLocalStorage } from "./Common";

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error && error.response && error.response.status == 401) {
    let videoDetails = getVideoDetailLocalStorage();
    reactLocalStorage.clear();
    if(videoDetails) { 
      setVideoDetailLocalStorage(videoDetails);
    }
    window.location.assign('/login');
    return;
  }
  return Promise.reject(error);
});

export * from './Auth/AuthActions';
export * from './UserAction';
export * from './DashboardAction';
export * from './VideoAction';
export * from './Common';
export * from './Story';



// WEBPACK FOOTER //
// ./actions/Index.js